var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2584_1840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16699 5.85498C4.71928 5.85498 5.16699 6.3027 5.16699 6.85498V15.0043C5.16699 15.8327 5.83857 16.5043 6.667 16.5043L12.6328 16.5042C13.1851 16.5042 13.6328 16.9519 13.6328 17.5042C13.6328 18.0565 13.1851 18.5042 12.6328 18.5042L6.66702 18.5043C4.73401 18.5043 3.16699 16.9373 3.16699 15.0043V6.85498C3.16699 6.3027 3.61471 5.85498 4.16699 5.85498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 15H14.667C15.7716 15 16.667 14.1046 16.667 13V6.52047C16.667 5.95074 16.424 5.40805 15.999 5.0286L13.7361 3.00812C13.3696 2.68088 12.8954 2.5 12.4041 2.5H8.66699C7.56242 2.5 6.66699 3.39543 6.66699 4.5V13C6.66699 14.1046 7.56242 15 8.66699 15Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2584_1840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.bef40c453659707fd3ea8009ac8aef60.svg";
export { ForwardRef as ReactComponent };